import { Box, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Color, FontStyle, JobDisplays } from "../../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
} from "../../../utils/jobUtils";
import {
  ResourceBody,
  ResourceContainer,
  ResourceHeader,
} from "../ResourcePanel";

const resource1 = [
  [
    "div",
    "Crafting an outstanding cover letter can be a daunting task, especially if you're an early career professional with limited experience to highlight. However, the cover letter is a crucial tool that helps you stand out from the crowd and demonstrate your enthusiasm for the job. Follow these tips to create a winning cover letter that showcases your skills and abilities:",
  ],
  ["x-div", ""],
  [
    "li-1",
    () => (
      <span>
        <b>Introduce Yourself: </b>Use the cover letter to introduce yourself,
        your accomplishments, and what you're proud of. Highlight your skills
        and explain how you can contribute to the team. Remember, there is no
        "one size fits all" CL, so tailor it to the job you're applying for.
      </span>
    ),
  ],
  [
    "li-2",
    () => (
      <span>
        <b>Answer Key Questions: </b>Answer questions like, "What is your
        philosophy?" "Who are you?" and "What do you bring to the table?"
        Provide honest answers that showcase your strengths and abilities.
      </span>
    ),
  ],
  [
    "li-3",
    () => (
      <span>
        <b>Highlight Accomplishments: </b>List relevant accomplishments and
        explain their impact. Be honest and concise. Use specific examples to
        demonstrate your skills and abilities.
      </span>
    ),
  ],
  [
    "li-4",
    () => (
      <span>
        <b>Read the Job Description: </b>Read the job description carefully, and
        tailor your cover letter to match it. Make sure to address each point in
        the job description, and avoid sending a cover letter that doesn't match
        it.
      </span>
    ),
  ],
  [
    "li-5",
    () => (
      <span>
        <b>Express Enthusiasm: </b>Show your enthusiasm for the role. Explain
        why you see yourself in the role and how you envision your best self in
        the position.
      </span>
    ),
  ],
  [
    "li-6",
    () => (
      <span>
        <b>Add Character: </b>Use the cover letter to add character and
        personality. Be professional, courteous, humble, and concise. Write it
        as if you're speaking to the hiring manager in person.
      </span>
    ),
  ],
  ["x-div", ""],
  [
    "div",
    "Remember, a great cover letter can help you stand out from the crowd. While a resume is a line item of your experience, the cover letter is where you can let your personality and skills shine through. Use this space to showcase your skills, demonstrate your enthusiasm, and convince the hiring manager that you're the best fit for the role.",
  ],
];

const resourceDescription = {
  showIdx: 2,
  lastElementShown: () => (
    <span>
      <b>Introduce Yourself: </b>Use the cover letter to introduce yourself,
      your accomplishments, and what you're proud of. Highlight your skills and
      explain how you can contr...
    </span>
  ),
  list: [...resource1],
};

const CoverLetterResource = ({
  job,
  fullHeight = false,
  showDescriptionOverlay,
}) => {
  const [showMore, setShowMore] = React.useState(false);
  // if (!job) return null;
  return (
    <ResourceContainer
      fullHeight={fullHeight}
      showDescriptionOverlay={showDescriptionOverlay}>
      <ResourceHeader
        title="Resources, Tips, and Templates for Writing an Amazing Cover Letter"
        subtitle="By Ex-Fortune 500 Recruiters"
      />
      <ResourceBody data={resourceDescription} />
      {/* Bottom row with url + apply button */}
      {/* <Box sx={{ ...jobButtonStyle, width: "100%", maxWidth: "100%" }}>
        <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
          Download Our Free Resume Template
        </DownloadTemplateWrapper>
      </Box> */}
    </ResourceContainer>
  );
};

export default CoverLetterResource;
